import { getCmsUsefulInformation } from "../../../app/api/getUsefulInformationt";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse } from "../../../Orchestrator/Types/Index";
import { ICmsUsefulInformation, ICmsUsefulInformationResponse } from "../../../Orchestrator/Types/Interface/ICmsUsefulInformaton";

class GetCmsUsefulInformationAction extends BaseAction<ICmsUsefulInformation[], void> {
  override async run(): Promise<ICmsUsefulInformation[] | null> {
    let listOfUsefulInformation: ICmsUsefulInformation[] = [];
    try {
      const response: IApiResponse<ICmsUsefulInformationResponse> = await getCmsUsefulInformation();

      if (response.status === "ok" && response.answer) {
        const usefulInformations = response.answer.data || [];
        listOfUsefulInformation = usefulInformations
        updateRecoilState("usefulInformationAtom", listOfUsefulInformation);
      } else {
        console.warn("Failed to fetch useful information.");
      }
    } catch (error: any) {
      console.error("Error fetching useful information:", error);
    } finally {
      return listOfUsefulInformation;
    }
  }
}

export const getCmsUsefulInformationAction = new GetCmsUsefulInformationAction()
